import { GuestProfile } from '@mews-commander/guest-profile';
import { LocalizedDateFromUtc } from '@mews-commander/ui';
import { UnicodeEntity } from '@mews/enums';
import { lt } from '@mews/framework';
import { Link, Stack, Typography } from '@optimus-web/core';
import { GuestAvatar, GuestAvatarProps } from '../../../../common';

interface GuestInfoProps
    extends Pick<GuestAvatarProps, 'fullName' | 'imageId'>,
        Pick<GuestProfile, 'id' | 'createdUtc' | 'updatedUtc'> {
    onClick: (id: string) => void;
}

export const GuestInfo = ({ fullName, imageId, createdUtc, updatedUtc, id, onClick }: GuestInfoProps) => (
    <Stack vertical spacing="100" itemAlignment="center">
        <GuestAvatar fullName={fullName} imageId={imageId} size="large" />
        <Link onClick={() => onClick(id)} inherit data-test-id={id}>
            <Typography underline textStyle="bodyLargeStrong" variant="secondary" align="center" as="div">
                {fullName}
            </Typography>
        </Link>
        <Stack vertical itemAlignment="center">
            <Typography textStyle="bodySmall" variant="secondary" align="center" as="div">
                <>{lt('Created')}</>
                <>{UnicodeEntity.Space}</>
                <LocalizedDateFromUtc utcString={createdUtc} />
            </Typography>
            <Typography textStyle="bodySmall" variant="secondary" align="center" as="div">
                <>{lt('LastUpdated')}</>
                <>{UnicodeEntity.Space}</>
                <LocalizedDateFromUtc utcString={updatedUtc} />
            </Typography>
        </Stack>
    </Stack>
);
